import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-empty-state',
  templateUrl: './report-empty-state.component.html',
  styleUrls: ['./report-empty-state.component.scss']
})
export class ReportEmptyStateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
